import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { PositionsInfoState } from "@reducers/types/HRM/positions-info-state";

import { getPositionsInfoRequest } from "@actions/HRM/positionsInfo/positions-info-action";
import { getPositionsInfoState } from "@selectors/HRM/positionsInfo/positions-info-selectors";

import { useAppSelector } from "@helpers/redux";

import { PositionType } from "@type/HRM/position";
import { PaginationRequestType, PaginationType } from "@type/HRM/pagination";

interface UsePositionsInfo {
  isPositionsInfoRequest: boolean;
  isPositionsInfoSuccess: boolean;
  isPositionsInfoFailed: boolean;
  deleteSuccess: boolean;
  deleteError: any;
  positionsInfo: PositionType[];
  pagination: PaginationType;
  handleQuery: (key: string, value: string | number | null) => void;
}

export const usePositionsInfo = (): UsePositionsInfo => {
  const [query, setQuery] = useState<PaginationRequestType>({
    page: 1,
    size: 10,
    positionOrder: "ASC",
  });

  const handleQuery = (key: string, value: string | number | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const getPositionsInfo = useAppSelector<PositionsInfoState>(
    getPositionsInfoState,
  );

  const isPositionsInfoRequest = getPositionsInfo.request as boolean;
  const isPositionsInfoSuccess = getPositionsInfo.success as boolean;
  const isPositionsInfoFailed = getPositionsInfo.failed as boolean;
  const { data: positionsInfo, pagination } = getPositionsInfo.data || {};

  const { deleteSuccess, deleteError } = getPositionsInfo;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPositionsInfoRequest(query));
  }, [dispatch, query]);

  return {
    handleQuery,
    isPositionsInfoRequest,
    isPositionsInfoSuccess,
    isPositionsInfoFailed,
    deleteSuccess,
    deleteError,
    positionsInfo,
    pagination,
  };
};
